import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/delete.svg'


const _hoisted_1 = { class: "call-container" }
const _hoisted_2 = {
  key: 0,
  class: "calling-overlay"
}
const _hoisted_3 = { class: "calling-content" }
const _hoisted_4 = { class: "calling-animation" }
const _hoisted_5 = {
  class: "phone-icon",
  style: {"color":"#ef4444"},
  viewBox: "0 0 24 24",
  width: "48",
  height: "48",
  fill: "currentColor"
}
const _hoisted_6 = { class: "video-grid" }
const _hoisted_7 = {
  key: 2,
  class: "outcome-overlay"
}
const _hoisted_8 = { class: "outcome-modal" }
const _hoisted_9 = { class: "outcome-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

import {
  getCurrentInstance,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref
} from "vue";
import { useRoute, useRouter } from "vue-router";
import CallTopBar from "@components/videoCall/CallTopBar.vue";
import VideoTile from "@components/videoCall/VideoTile.vue";
import CallControls from "@components/videoCall/CallControls.vue";
import { SignalRConnector } from "@/plugins/SignalRConnector.js";
import { agoraService } from "@/plugins/AgoraService";

interface CallData {
  videoCallId: number;
  channelName: string;
  token: string;
  appId: string;
  uid: number;
  patientId: string;
  patientName: string;
  professionalName: string;
  professionalId: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallWindow',
  setup(__props) {

const instance = getCurrentInstance();
const $axios = instance?.appContext.config.globalProperties.$axios;
const $Session = instance?.appContext.config.globalProperties.$Session;
const $userSessionName =
  instance?.appContext.config.globalProperties.$userSessionName;

const route = useRoute();
const router = useRouter();

// Estados da chamada: 'calling' | 'connected' | 'ended'
const callState = ref<"calling" | "connected" | "ended">("calling");

const callData = ref<CallData | null>(null);
let signalRConnection: any = null;

const state = reactive({
  connected: false,
  muted: false,
  cameraOff: false,
  remoteAudioMuted: false,
  localStream: null as MediaStream | null,
  remoteStream: null as MediaStream | null
});

const ui = reactive({
  swapped: false,
  showOutcome: false,
  submittingOutcome: false,
  rejected: false
});

const outcomeText = ref("");
const callFinalized = ref(false);

const startedAt = ref<number>(0);
const now = ref<number>(Date.now());
let tick: number | undefined;

function loadCallData() {
  const pathParts = window.location.pathname.split("/");
  const callId = pathParts[pathParts.length - 1] || route.params.callId;
  const key = `videoCall_${callId}`;
  const stored = localStorage.getItem(key);

  if (stored) {
    callData.value = JSON.parse(stored);
    localStorage.removeItem(key);
  }
}

async function startSignalRListener() {
  if (!callData.value) return;

  try {
    signalRConnection = await SignalRConnector.startSignalR(
      "VideoCallHub",
      (connection: any) => {
        connection.on("CallAccepted", () => {
          onCallAccepted();
        });

        connection.on("CallRejected", () => {
          onCallRejected();
        });

        connection.on("CallEnded", () => {
          showOutcomeModal();
        });
      },
      0,
      callData.value.professionalId,
      "videocall"
    );

  } catch (error) {
    console.error("[SignalR] Erro ao conectar:", error);
  }
}

async function onCallAccepted() {
  console.log("[VideoCall] onCallAccepted - paciente aceitou a chamada");
  callState.value = "connected";
  startedAt.value = Date.now();
  tick = window.setInterval(() => (now.value = Date.now()), 250);

  if (!callData.value) return;

  agoraService.on("localStream", (stream) => {
    console.log("[Agora] localStream recebido");
    state.localStream = stream;
  });
  agoraService.on("remoteStream", (stream) => {
    console.log("[Agora] remoteStream recebido");
    state.remoteStream = stream;
  });
  agoraService.on("userLeft", () => {
    console.log("[Agora] userLeft - paciente saiu do canal");
    showOutcomeModal();
  });
  agoraService.on("remoteAudioMuted", (muted: boolean) => {
    console.log("[Agora] remoteAudioMuted:", muted);
    state.remoteAudioMuted = muted;
  });

  try {
    const { appId, channelName, token, uid } = callData.value;
    console.log("[Agora] joinChannel iniciando...", { channelName, uid });
    await agoraService.joinChannel(appId, channelName, token, uid);
    console.log("[Agora] joinChannel conectado com sucesso");
    state.connected = true;
  } catch (error) {
    console.error("[Agora] Erro ao conectar ao canal:", error);
  }
}

function onCallRejected() {
  console.log("[VideoCall] onCallRejected - chamada recusada pelo paciente");
  callFinalized.value = true;
  ui.rejected = true;
  setTimeout(() => {
    window.opener?.postMessage(
      { type: "call-finished", patientId: callData.value?.patientId },
      window.location.origin
    );
    closeWindow();
  }, 1500);
}

function buildAuthHeaders(): Record<string, string> {
  const token = $Session?.get($userSessionName)?.token?.Value;
  return token ? { Authorization: `bearer ${token}` } : {};
}

async function cancelCall() {
  console.log("[VideoCall] cancelCall - profissional cancelou a chamada");
  callFinalized.value = true;
  try {
    await $axios.post(
      `/api/call/${callData.value?.videoCallId}/cancell`,
      { statusName: "NaoAtendida" },
      { headers: buildAuthHeaders() }
    );
  } catch (error) {
    console.error("Erro ao cancelar chamada:", error);
  }
  window.opener?.postMessage(
    {
      type: "call-finished",
      patientId: callData.value?.patientId,
      status: "cancelada"
    },
    window.location.origin
  );
  closeWindow();
}
function toggleMute() {
  state.muted = !state.muted;
  agoraService.setMuted(state.muted);
}

function toggleCamera() {
  state.cameraOff = !state.cameraOff;
  agoraService.setCameraOff(state.cameraOff);
}

function swapVideos() {
  ui.swapped = !ui.swapped;
}


function closeWindow() {
  try {
    window.close();
  } catch (err) {
    console.warn("[Window] não conseguiu fechar:", err);
    router.push({ name: "patientTickets" }).catch(() => router.back());
  }
}

function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  if (h > 0) return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

async function showOutcomeModal() {
  if (callState.value === "ended") return;
  console.log("[VideoCall] showOutcomeModal - encerrando chamada");
  const duration = startedAt.value > 0 ? formatDuration(Date.now() - startedAt.value) : null;
  callState.value = "ended";
  callFinalized.value = true;
  if (tick) clearInterval(tick);
  await agoraService.leave();
  console.log("[Agora] leave - desconectado do canal");
  state.localStream = null;
  state.remoteStream = null;

  try {
    await $axios.post(
      `/api/call/${callData.value?.videoCallId}/finish`,
      {},
      { headers: buildAuthHeaders() }
    );
  } catch (error) {
    console.error("Erro ao finalizar chamada:", error);
  }

  window.opener?.postMessage(
    { type: "call-finished", patientId: callData.value?.patientId },
    window.location.origin
  );

  ui.showOutcome = true;
}

function skipOutcome() {
  closeWindow();
}

async function submitOutcome() {
  ui.submittingOutcome = true;
  try {
    if (outcomeText.value.trim()) {
      await $axios.put(
        `/api/call/${callData.value?.videoCallId}`,
        { outcome: outcomeText.value.trim() },
        { headers: buildAuthHeaders() }
      );
    }
  } catch (error) {
    console.error("Erro ao enviar desfecho:", error);
  }

  closeWindow();
}

function buildCallActionUrl(callId: number, isRinging: boolean): string {
  const baseUrl = $axios?.defaults?.baseURL ?? "";
  const action = isRinging ? "cancell" : "finish";
  return `${baseUrl}/api/call/${callId}/${action}`;
}

function endCallOnWindowClose() {
  if (callFinalized.value || !callData.value) return;
  callFinalized.value = true;

  const isRinging = callState.value === "calling";

  fetch(buildCallActionUrl(callData.value.videoCallId, isRinging), {
    method: "POST",
    headers: { "Content-Type": "application/json", ...buildAuthHeaders() },
    body: JSON.stringify(isRinging ? { statusName: "NaoAtendida" } : {}),
    keepalive: true
  }).catch((error) =>
    console.error("Erro ao encerrar chamada no fechamento:", error)
  );

  window.opener?.postMessage(
    {
      type: "call-finished",
      patientId: callData.value.patientId,
      ...(isRinging ? { status: "cancelada" } : {})
    },
    window.location.origin
  );
}

function confirmBeforeClose(event: BeforeUnloadEvent) {
  if (callFinalized.value) return;
  event.preventDefault();
  event.returnValue = "";
}

onMounted(async () => {
  try {
    loadCallData();
  } catch (error) {
    console.error("Erro ao carregar callData:", error);
  }

  window.addEventListener("beforeunload", confirmBeforeClose);
  window.addEventListener("pagehide", endCallOnWindowClose);

  await startSignalRListener();
});

onBeforeUnmount(() => {
  if (tick) clearInterval(tick);
  agoraService.leave();

  window.removeEventListener("beforeunload", confirmBeforeClose);
  window.removeEventListener("pagehide", endCallOnWindowClose);

  if (signalRConnection) {
    SignalRConnector.stopSignalR(signalRConnection, "videocall");
  }

});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (callState.value === 'calling')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (ui.rejected)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[1] || (_cache[1] = [
                      _createElementVNode("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" }, null, -1)
                    ])))
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "calling-title" }, " Chamada Recusada ", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "calling-subtitle" }, " O paciente recusou a chamada. Fechando... ", -1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"calling-animation\" data-v-f26f3216><div class=\"pulse-ring\" data-v-f26f3216></div><div class=\"pulse-ring delay-1\" data-v-f26f3216></div><div class=\"pulse-ring delay-2\" data-v-f26f3216></div><svg class=\"phone-icon\" viewBox=\"0 0 24 24\" width=\"48\" height=\"48\" fill=\"currentColor\" data-v-f26f3216><path d=\"M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z\" data-v-f26f3216></path></svg></div><h2 class=\"calling-title\" data-v-f26f3216> Chamando... </h2><p class=\"calling-subtitle\" data-v-f26f3216> Aguardando paciente atender </p>", 3)),
                  _createElementVNode("button", {
                    class: "cancel-call-btn",
                    onClick: cancelCall
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "24",
                      height: "24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.948.948 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z" })
                    ], -1),
                    _createTextVNode(" Cancelar Chamada ")
                  ]))
                ], 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(CallTopBar, {
            connected: state.connected,
            "started-at": startedAt.value,
            "current-time": now.value,
            "professional-name": callData.value?.professionalName
          }, null, 8, ["connected", "started-at", "current-time", "professional-name"]),
          _createElementVNode("main", _hoisted_6, [
            _createVNode(VideoTile, {
              variant: "remote",
              stream: ui.swapped ? state.localStream : state.remoteStream,
              name: 
            ui.swapped
              ? callData.value?.professionalName
              : callData.value?.patientName || 'Paciente'
          ,
              role: ui.swapped ? 'Profissional' : 'Paciente',
              label: 
            ui.swapped
              ? callData.value?.professionalName
              : callData.value?.patientName || 'Paciente'
          ,
              "show-self": ui.swapped,
              "audio-muted": ui.swapped ? false : state.remoteAudioMuted,
              onDblclick: swapVideos
            }, null, 8, ["stream", "name", "role", "label", "show-self", "audio-muted"]),
            _createVNode(VideoTile, {
              variant: "local",
              stream: ui.swapped ? state.remoteStream : state.localStream,
              name: 
            ui.swapped
              ? callData.value?.patientName || 'Paciente'
              : callData.value?.professionalName
          ,
              role: ui.swapped ? 'Paciente' : 'Profissional',
              label: 
            ui.swapped
              ? callData.value?.patientName || 'Paciente'
              : callData.value?.professionalName
          ,
              "show-self": !ui.swapped,
              "audio-muted": ui.swapped ? state.remoteAudioMuted : false,
              onSwap: swapVideos
            }, null, 8, ["stream", "name", "role", "label", "show-self", "audio-muted"])
          ]),
          _createVNode(CallControls, {
            muted: state.muted,
            "camera-off": state.cameraOff,
            onToggleMute: toggleMute,
            onToggleCamera: toggleCamera,
            onEndCall: showOutcomeModal
          }, null, 8, ["muted", "camera-off"])
        ], 64)),
    (ui.showOutcome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "outcome-close",
              title: "Fechar sem salvar",
              onClick: closeWindow
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Fechar"
              }, null, -1)
            ])),
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "outcome-title" }, " Desfecho da Chamada ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "outcome-subtitle" }, " Chamada encerrada. Deseja adicionar um desfecho? ", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((outcomeText).value = $event)),
              class: "outcome-textarea",
              placeholder: "Escreva o desfecho da chamada...",
              rows: "5"
            }, null, 512), [
              [_vModelText, outcomeText.value]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "button is-rounded outcome-skip",
                disabled: ui.submittingOutcome,
                onClick: skipOutcome
              }, " Pular ", 8, _hoisted_10),
              _createElementVNode("button", {
                class: "button is-rounded default",
                disabled: ui.submittingOutcome,
                onClick: submitOutcome
              }, _toDisplayString(ui.submittingOutcome ? "Enviando..." : "Salvar Desfecho"), 9, _hoisted_11)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})